import { Link } from "react-router-dom";
import useScrollReveal from "../../hooks/useScrollReveal";

const TestimonialsSection = () => {
  const headerReveal = useScrollReveal({ threshold: 0.2 });
  const quotesReveal = useScrollReveal({ threshold: 0.08 });

  const quotes = [
    { text: "« Je suis venu en crabe. Et je repars en paix. »", name: "André", city: "Margencel" },
    { text: "« J'ai trouvé des réponses. Et surtout du lien. »", name: "Estelle", city: "Évian" },
    { text: "« J'ai pu tomber le gilet pare-balles. Et aimer. »", name: "Mélissa", city: "" },
    { text: "« Ce que j'ai vécu ici, je ne pourrais pas l'expliquer… »", name: "Valérie", city: "Genève" },
    { text: "« Je ne savais pas que j'en avais autant besoin… »", name: "Lydie", city: "Margencel" },
  ];

  return (
    <section id="temoignages-home" className="py-24 sm:py-36 px-6 bg-[#F3E5CF]">
      <div className="max-w-2xl mx-auto text-center space-y-12">

        <div
          ref={headerReveal.ref}
          className={`space-y-4 scroll-reveal-slow ${headerReveal.isVisible ? "visible" : ""}`}
        >
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#C5A059]">
            Paroles vivantes
          </p>
          <h3 className="font-serif text-xl sm:text-2xl text-[#3F2A24]">
            Témoignages
          </h3>
          {/* ═══ CONSERVATION TEMPORAIRE — ancien texte ═══
          <p className="font-serif text-sm text-[#3F2A24]/60 italic">
            Ce qu'elles et ils ont traversé
          </p>
          ═══ FIN CONSERVATION TEMPORAIRE ═══ */}
          <p className="font-serif text-sm text-[#3F2A24]/60 italic">
            Ce que les coconé·e·s ont traversé
          </p>
          <div className="w-12 h-[1px] bg-[#C5A059]/40 mx-auto" />
        </div>

        {/* Quotes */}
        <div ref={quotesReveal.ref} className="space-y-5">
          {quotes.map((q, i) => (
            <div
              key={`testimonial-${q.name}-${q.city || i}`}
              className={`group rounded-2xl px-6 py-6 bg-[#E8D2B5]/40 hover:bg-[#8d7a6b] transition-colors duration-500 cursor-default formula-card-premium scroll-reveal scroll-reveal-delay-${Math.min(i + 1, 4)} ${quotesReveal.isVisible ? "visible" : ""}`}
            >
              <p className={`font-serif text-base sm:text-lg text-[#3F2A24]/70 group-hover:text-[#F3E5CF]/80 italic leading-relaxed transition-colors duration-500`}>
                {q.text}
              </p>
              <p className={`text-sm text-[#3F2A24] group-hover:text-[#C5A059] font-medium mt-3 transition-colors duration-500`}>
                — {q.name}{q.city ? ` · ${q.city}` : ''}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="pt-8 scroll-reveal scroll-reveal-delay-4" style={{ opacity: quotesReveal.isVisible ? 1 : 0, transform: quotesReveal.isVisible ? 'translateY(0)' : 'translateY(18px)', transition: 'opacity 0.8s ease-out 0.5s, transform 0.8s ease-out 0.5s' }}>
          <Link
            to="/temoignages"
            className="inline-flex items-center justify-center px-12 py-5 rounded-full bg-[#3F2A24] text-[#F3E5CF] text-xs tracking-[0.18em] uppercase font-medium hover:bg-[#C5A059] hover:text-[#3F2A24] transition-all duration-500 min-h-[52px]"
            data-testid="home-testimonials-cta"
          >
            Je laisse ces mots me traverser
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
